var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNf = function SvgNf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M17.216 1.19A11.952 11.952 0 0 0 12 0c-1.87 0-3.64.428-5.217 1.19L5.738 12l1.044 10.809a11.951 11.951 0 0 0 5.217 1.19c1.87 0 3.64-.427 5.217-1.19l1.044-10.81L17.216 1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M6.783 1.191A12 12 0 0 0 0 12.001a12 12 0 0 0 6.783 10.808V1.19ZM17.217 1.191V22.81A12 12 0 0 0 23.999 12a12 12 0 0 0-6.782-10.809ZM15.131 15.652l-3.13-9.913-3.13 9.913h2.347v2.608h1.565v-2.608h2.348Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNf;